// src/services/booking-service.js
//
// Client-side service for creating bookings via the Cloud Function.
// The function stores the booking in Firestore and (if the practitioner has
// Google Calendar connected) creates a calendar event with an attendee invite.

const FUNCTIONS_BASE = 'https://us-west1-divine-frameworks-6cb16.cloudfunctions.net';

/**
 * Creates a booking by calling the syncBookingToCalendar Cloud Function.
 *
 * @param {Object} bookingData
 * @param {string} bookingData.practitionerId
 * @param {{ name: string, duration: number, price: number }} bookingData.service
 * @param {{ firstName: string, lastName: string, email: string, phone: string, message: string }} bookingData.client
 * @param {string} bookingData.dateTime  — ISO 8601 (e.g. "2026-03-05T14:00:00")
 * @param {string} bookingData.timezone — IANA timezone (e.g. "America/Los_Angeles")
 * @returns {Promise<{ success: boolean, bookingId: string, calendarSynced: boolean, calendarEventId: string|null }>}
 */
export async function createBooking(bookingData) {
  const response = await fetch(`${FUNCTIONS_BASE}/syncBookingToCalendar`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(bookingData),
  });

  if (!response.ok) {
    throw new Error('Failed to create booking');
  }

  return response.json();
}
